import { CircularProgress } from "@mui/material";
import React from "react";
import styles from "./spinner.module.scss";

const Spinner = (): React.JSX.Element => (
  <div className={styles.spinnerContainer}>
    <CircularProgress className={styles.spinner} />
  </div>
);

export default Spinner;
